module.exports = __webpack_public_path__ + "static/media/btc.5bde33c1.png";